<template>
    <div :style="'padding-left: 115px; width: ' + useMapWidthInPixels + 'px; margin: 0 auto; transition: width 0.3s'">
        <div v-for="(row, y) in grid" :key="'row' + y" class="grid-x">
            <!-- for each row, we need to go up to but not include the active cell and steal cells from after it -->
            <!-- then we do the rest of the row, and skip connector cells that we stole before -->
            <template v-for="(c, x) in row">
                <template v-if="nodes[c].maxChildX > 0">
                    <map-node
                        v-for="x2 in (nodes[c].maxChildX - x)"
                        :key="'pre+' + x2 + '+' + x + '+' + y"
                        :x="x2 + x"
                        :y="y"
                        :grid="grid"
                        :node="nodes[c].selectedChildIndex === 0 ? nodes.empty : nodes.connector" 
                        :nodes="nodes"
                        :selected-rows="selectedRows"
                        :selected-columns="selectedColumns"
                        :active-path="highlightConnectors[x + '-' + y]"
                        :collapse-range="[nodes[c].selectedChildX >= 0 ? nodes[c].selectedChildX + 1 : x, nodes[c].maxChildX]"
                        :force-h-connector="true"
                        @select="select(c, x, y)"
                        @openSteps="openSteps(c)"
                    />
                </template>
                <template v-if="nodes[c].title">
                    <map-node
                        :key="'mn+' + x + '+' + y"
                        :x="x"
                        :y="y"
                        :grid="grid"
                        :node="nodes[c]"
                        :nodes="nodes"
                        :selected-rows="selectedRows"
                        :selectedColumns="selectedColumns"
                        :activePath="highlightConnectors[x + '-' + y]"
                        @select="select(c, x, y)"
                        @openSteps="openSteps(c)"
                    />
                    <map-node v-for="x2 in (nodes[c].postX)"
                        :foo="x + x2"
                        :key="'post+' + x2 + '+' + x + '+' + y"
                        :x="x2 + x"
                        :y="y"
                        :grid="grid"
                        :node="nodes[row[x + x2]]"
                        :nodes="nodes"
                        :selected-rows="selectedRows"
                        :selected-columns="selectedColumns"
                        :active-path="highlightConnectors[(x + x2) + '-' + y]"
                        :collapse-range="[x + 1, nodes[c].selectedChildX > 0 ? nodes[c].selectedChildX : -1]"
                        :force-h-connector="false"
                    />
                </template>
            </template>
        </div>
        <!-- div v-for="(row, y) in grid" :key="'xrow' + y">
            <pre>
                <span v-for="(c, x) in row" :key="x+'x+'+y" :x="x" :y="y"> {{ nodes[c].title }}</span>
            </pre>
        </div -->
        <!-- pre>
            {{ tree }}
            <span v-for="(row, y) in grid" :key="'row' + y">
            <span v-for="(c, x) in row" :key="x+'+'+y">{{ c.title ? c.title : ( c.connector ? '--' : '..') }} </span>
            </span>
        </pre -->
    </div>
</template>
<script>
import MapNode from '@/components/MapNode.vue'
import velocity from 'velocity-animate';
import Vue from 'vue';

// const tree = [
    // {
    //     title: 'Entry/Junior',
    //     children: [
    //         {
    //             title: 'Senior',
    //             children: [
    //                 {
    //                     title: 'Director',
    //                     children: [
    //                         {
    //                             title: 'VP',
    //                             children: [
    //                                 {
    //                                     title: 'Senior VP'
    //                                 }
    //                             ]
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     title: 'Jr. Specialist',
    //                     children: [
    //                         {
    //                             title: 'Senior Specialist',
    //                             children: [
    //                                 {
    //                                     title: '08',
    //                                     children: [
    //                                         {
    //                                             title: '09',
    //                                             children: [
    //                                                 {
    //                                                     title: '10'
    //                                                 }
    //                                             ]
    //                                         },
    //                                         {
    //                                             title: '11'
    //                                         },
    //                                         {
    //                                             title: 'X1'
    //                                         }
    //                                     ]
    //                                 }
    //                             ]
    //                         },
    //                         {
    //                             title: '12',
    //                             children: [
    //                                 {
    //                                     title: '13'
    //                                 },
    //                                 {
    //                                     title: '14'
    //                                 }
    //                             ]
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     title: '15',
    //                     children: [
    //                         {
    //                             title: '16'
    //                         }
    //                     ]
    //                 }
    //             ]
    //         }
    //     ]
    // }
    // {
    //     title: 'Junior Developer',
    //     children: [
    //         {
    //             title: 'Software Developer',
    //             children: [
    //                 {
    //                     title: 'Senior Developer',
    //                     children: [
    //                         {
    //                             title: 'Technical Lead',
    //                             children: [
    //                                 {
    //                                     title: 'Software Architect'
    //                                 },
    //                                 {
    //                                     title: 'Principal Engineer'
    //                                 },
    //                                 {
    //                                     title: 'Project Manager',
    //                                     children: [
    //                                         {
    //                                             title: 'Team Manager'
    //                                         }
    //                                     ]
    //                                 }
    //                             ]
    //                         }
    //                     ]
    //                 }
    //             ]
    //         }
    //     ]
    // }
    // {
    //     title: 'Developer, Tester',
    //     children: [
    //         {
    //             title: 'Senior Developer, Scrum Master',
    //             children: [
    //                 {
    //                     title: 'Technical Lead',
    //                     children: [
    //                         {
    //                             title: 'Associate Architect',
    //                             children: [
    //                                 {
    //                                     title: 'Software Architect'
    //                                 }
    //                             ]
    //                         },
    //                         {
    //                             title: 'Software Technical Manager'
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     title: 'Senior Scrum Master',
    //                     children: [
    //                         {
    //                             title: 'Agile Technical Coach'
    //                         }
    //                     ]
    //                 }
    //             ]
    //         },
    //         {
    //             title: 'Software Development Engineer in Test',
    //             children: [
    //                 {
    //                     title: 'Test Manager',
    //                     children: [
    //                         {
    //                             title: 'Software Quality Manager'
    //                         }
    //                     ]
    //                 }
    //             ]
    //         }
    //     ]
    // }
// ];

export default {
    components: { MapNode },
    props: {
        tree: {
            type: Array
        },
        selectedId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            grid: [],
            nodeId: 0,
            nodes: {
                empty: { connector: false, title: '' },
                connector: { connector: true, title: '' }
            },
            rootNodeId: 0,
            selectedNodeId: 0,
            selectedColumns: [],
            selectedRows: [],
            useMapWidthInPixels: 0,
            highlightConnectors: {},
            selectedX: -1,
            selectedY: -1
        }
    },
    mounted() {
        // really we need to keep track of our left-iness by
        // the number of siblings before us (added to our parents
        // number of sibling's before it)
        // this.tree.forEach((n) => {
        //     this.pn1(n, 0, 0);
        // });
        const n = this.pn1(this.tree[0], 0, 0);
        this.rootNodeId = n.nodeId;
        for (let y = 0; y < this.grid.length; y++) {
            let nid = false;

            for (let x = 0; x < this.grid[y].length; x++) {
                let n = this.nodes[this.grid[y][x]];
                if (n.title.length > 0) {
                    nid = this.grid[y][x];
                } else if (nid !== false) {
                    this.nodes[nid].postX = this.nodes[nid].postX + 1;
                }
            }
        }
        if (this.selectedNodeId) {
            Vue.nextTick(() => {
                this.select(this.selectedNodeId);
            });
        }
    },
    computed: {
        maxX() {
            let x = 0;
            // this.nodes.forEach((n) => {
            //     if (n.x && n.x > x) {
            //         x = n.x;
            //     }
            // });
            for (var nid in this.nodes) {
                if (this.nodes[nid].x && this.nodes[nid].x > x) {
                    x = this.nodes[nid].x;
                }
            }
            return x;
        },
        mapWidthInPixels() {
            return (this.maxX + 1) * 150 +
                ((this.selectedColumns.length + 1) * (210 - 150)) +
                115;
        }
    },
    watch: {
        mapWidthInPixels(v, o) {
            if (o && o > v) { // shrinking
                setTimeout(() => {
                    this.useMapWidthInPixels = this.mapWidthInPixels;
                }, 4000);
            } else { // growing
                this.useMapWidthInPixels = this.mapWidthInPixels;
            }
        }
    },
    methods: {
        newNodeId() {
            this.nodeId = this.nodeId + 1;
            return 'n' + this.nodeId;
        },
        pn1(node, x, y) {
            if (!node.nodeId) {
                node.nodeId = this.newNodeId();
            }
            if (node.id === this.selectedId) {
                this.selectedNodeId = node.nodeId;
            }
            while (y >= this.grid.length) {
                this.grid.push([]);
            }
            while (x >= this.grid[y].length) {
                this.grid[y].push('empty');
            }
            node.x = x;
            node.y = y;
            node.selectedChildIndex = false;
            node.selectedChildX = -1;
            node.postX = 0;
            this.grid[y][x] = node.nodeId;
            if (node.children !== undefined && node.children.length > 0) {
                x = x - 1;
                for (let i = 0; i < node.children.length; i++) {
                    node.children[i].parentId = node.nodeId;
                    while ((x + 2) > this.grid[y].length) {
                        this.grid[y].push('connector');
                    }                    
                    x = x + 1;
                    const cn = this.pn1(node.children[i], x, y + 1);
                    node.maxChildX = x;
                    x = cn.next_x;
                }
            }
            let nn = {};
            // addition of new attributes isn't reactive
            // but changing existing attributes is?
            nn[node.nodeId] = Object.assign({ selected: false }, node);
            this.nodes = Object.assign({}, this.nodes, nn);
            node.next_x = x;
            return node;
        },
        clearTreeSelect(nodeId) {
            let n = this.nodes[nodeId];
            n.selected = false;
            n.toTheRightSelected = false;
            n.selectedChildIndex = false;
            n.selectedChildX = -1;
            if (n.children) {
                n.children.forEach((c) => this.clearTreeSelect(c.nodeId));
            }
        },
        treeSelectWithParents(nodeId, fromX, fromY, selectedChildId = false, selectedChildX = -1) {
            let n = this.nodes[nodeId];
            n.selected = true;
            if (fromX > n.x) {
                n.toTheRightSelected = true;
            }
            if (!this.selectedRows.includes(n.y)) {
                this.selectedRows.push(n.y);
            }
            if (!this.selectedColumns.includes(n.x)) {
                this.selectedColumns.push(n.x);
            }
            let nh = {};
            for (let i = n.x; i < fromX; i++) {
                nh[i + '-' + n.y] = true;
            }
            for (let i = n.y; i <= fromY; i++) {
                // nh[n.x + '-' + i] = true;
            }
            n.selectedChildX = selectedChildX;
            n.selectedChildIndex = false;
            if (selectedChildId && n.children) {
                n.children.forEach((c, i) => {
                    if (c.nodeId === selectedChildId) {
                        n.selectedChildIndex = i;
                    }
                });
            }
            this.highlightConnectors = Object.assign(this.highlightConnectors, nh);
            if (n.parentId) {
                this.treeSelectWithParents(n.parentId, n.x, n.y, n.nodeId, selectedChildX >= 0 ? selectedChildX : n.x);
            }
        },
        select(nodeId) {
            this.selectedColumns = [];
            this.selectedRows = [];
            this.highlightConnectors = {};
            this.clearTreeSelect(this.rootNodeId);
            this.nodes[nodeId].selected = true;
            this.selectedX = this.nodes[nodeId].x;
            this.selectedY = this.nodes[nodeId].y;
            this.treeSelectWithParents(nodeId, this.nodes[nodeId].x, this.nodes[nodeId].y);
            this.$emit('select', this.nodes[nodeId].id);
            const nodeEl = document.querySelector('[data-node-id="' + nodeId + '"]');
            if (nodeEl) {
                velocity(nodeEl, 'scroll', { axis: 'x', delay: 333, offset: -100 });
            } else {
                // console.error('no node for ' + nodeId);
            }
            this.$emit('selectPosition', this.nodes[nodeId].id);
        },
        openSteps(nodeId) {
            this.$emit('openSteps', this.nodes[nodeId].checklistId, this.nodes[nodeId].title, this.nodes[nodeId].description);
        }
    }
}
</script>